import { useNavigation, useRoute } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { ProgressDialog } from '../../comps/ProgressDialog'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { getFingerPrintData, parseBioMetricDeviceInfo } from '../../util/utill'
import { FingerPrintScanner } from '../ScanFingerprintScreen/FingerPrintScanner'

export const AgentAuthScreen = () => {
  const { asyncAuthenticateAgent, setBioMetricDeviceInfo, getConsent, sendEventAsync } = useStores((root) => ({
    asyncAuthenticateAgent: root.agent.asyncAuthenticateAgent,
    setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
    getConsent: root.consents.getConsent,
    sendEventAsync: root.agent.session.sendEventAsync,
  }))

  const route: any = useRoute()
  const navigation = useNavigation<any>()

  const consent = getConsent('AGENT_FINGER_PRINT')

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Agent Authentication' })
  }, [navigation])

  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = useState(false)
  const [lazyAsyncAuthenticateAgent, asyncAuthenticateAgentHandler] = useLazyApiData(asyncAuthenticateAgent)
  const [fingerPrintError, setFingerPrintError] = useState({ code: '', error: '', title: '' })

  const onScanSuccess = (sucess: any) => {
    getFingerPrintData(sucess, undefined).then((fingerprintData: any) => {
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      lazyAsyncAuthenticateAgent(fingerprintData, consent, 42)
      setShouldShowFingerPrintModel(false)
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }
  const onFigerprintSubmit = (authMode: 'FACE' | 'FINGER_PRINT') => {
    if (window.AepsWebViewInterface) {
      setShouldShowFingerPrintModel(true)
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode })
    } else {
      lazyAsyncAuthenticateAgent('', consent)
    }
  }

  const reScanFingerPrint = (authenticationMode: 'FACE' | 'FINGER_PRINT') => {
    setFingerPrintError({ code: '', error: '', title: '' })
    nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode: authenticationMode })
  }

  useEffect(() => {
    if (asyncAuthenticateAgentHandler.state === 'fulfilled') {
      navigation.navigate(Screens.REVIEW_CASH_WITHDRAWAL, {
        ...route.params,
        authorizationCode: asyncAuthenticateAgentHandler.data?.authorizationCode,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asyncAuthenticateAgentHandler.state])

  return (
    <>
      <FingerPrintScanner
        onSubmit={onFigerprintSubmit}
        isLoading={asyncAuthenticateAgentHandler.state === 'pending'}
        title={'Agent Authentication'}
        consent={consent}
      />
      <ProgressDialog
        error={fingerPrintError}
        onRetry={reScanFingerPrint}
        show={shouldShowFingerPrintModel || asyncAuthenticateAgentHandler.state === 'pending'}
        type={
          fingerPrintError.code ? 'error' : asyncAuthenticateAgentHandler.state === 'pending' ? 'loader' : 'fingerprint'
        }
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
    </>
  )
}
